import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import fordLogo from '../../assets/ford_logo.png';
import lincolnLogo from '../../assets/lincoln_logo.png';
const logoStyle = {
    height: '100%',
    width: '80px',
    objectFit: 'contain',
};
const LincolnLogo = () => {
    return (_jsx("div", { className: `pt-1 px-2`, style: { height: '34px' }, children: _jsx("img", { src: lincolnLogo, alt: 'Lincoln', style: logoStyle }) }));
};
const FordLogo = () => {
    return (_jsx("div", { className: `pt-1 px-2`, style: { height: '34px' }, children: _jsx("img", { src: fordLogo, alt: 'Ford', style: logoStyle }) }));
};
export default function Logo() {
    try {
        const storedThemeValue = sessionStorage.getItem('theme-storage');
        if (storedThemeValue) {
            const themeState = JSON.parse(storedThemeValue).state;
            const isLincoln = themeState === null || themeState === void 0 ? void 0 : themeState.theme.startsWith('lincoln');
            if (themeState) {
                return _jsx(_Fragment, { children: isLincoln ? _jsx(LincolnLogo, {}) : _jsx(FordLogo, {}) });
            }
        }
    }
    catch (error) {
        // sessionStorage is not available or theme-storage is not a valid JSON
        // Fallback to ford
        return _jsx(FordLogo, {});
    }
    return _jsx(FordLogo, {});
}
